module.exports = __webpack_public_path__ + "img/sunFlower-8.5ec26503.jpg";